import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { MARKET_INSIGHT_DRAWER_ID } from '~/hooks/use-market-insights-drawer/useMarketInsightsDrawer';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

import { useMarketInsightsStore } from '../../hooks/useMarketInsightsStore';
import { MarketInsightDrawer } from './MarketInsightDrawer';
import { RevampMarketInsightDrawer } from './RevampMarketInsightDrawer';

export const MarketInsightDrawerRender = () => {
  const { params } = useQueryParams();
  const activeDrawer = params[queryKeys.activeDrawer];
  const activeDate = params[queryKeys.activeDate];
  const insightId = params[queryKeys.activeInsight];
  const { getActiveMarketInsightsGroup, insight } = useMarketInsightsStore(
    state => ({
      getActiveMarketInsightsGroup: state.getActiveMarketInsightsGroup,
      insight: state.selectedMarketInsight,
    })
  );

  const activeInsightsGroup = activeDate
    ? getActiveMarketInsightsGroup(activeDate?.split('T')[0])
    : null;

  if (activeDrawer === MARKET_INSIGHT_DRAWER_ID) {
    if (insightId && insight) {
      return (
        <ErrorBoundaryWrapper showBorder={false}>
          <MarketInsightDrawer insight={insight} />
        </ErrorBoundaryWrapper>
      );
    } else if (activeInsightsGroup) {
      return (
        <ErrorBoundaryWrapper showBorder={false}>
          <RevampMarketInsightDrawer
            activeInsightsGroup={activeInsightsGroup}
          />
        </ErrorBoundaryWrapper>
      );
    }
  }

  return null;
};
